import toast from 'react-hot-toast';
import { takeEvery, put, call } from 'redux-saga/effects';
import * as adminApi from '../../api/adminApi';
import * as actions from '../actions/adminActions';

export function* addSite({ payload: { site } }) {
  try {
    yield call(adminApi.addSite, site);
    yield put(actions.addSiteSuccess());
    yield put(actions.getSites());
    toast.success('Site added.');
  } catch (e) {
    yield put(actions.addSiteFail());
    toast.error('An error occurred adding the new site.');
  }
}
export function* updateSite({ payload: { site } }) {
  try {
    yield call(adminApi.updateSite, site);
    yield put(actions.updateSiteSuccess());
    yield put(actions.getSites());
    toast.success('Site updated.');
  } catch (e) {
    yield put(actions.updateSiteFail());
    toast.error('An error occurred updating the site.');
  }
}
export function* getSites() {
  try {
    const sites = yield call(adminApi.getSites);
    yield put(actions.getSitesSuccess(sites));
  } catch (e) {
    yield put(actions.getSitesFail());
    toast.error('An error occurred retrieving the sites.');
  }
}

export function* setSite({ payload: { siteId } }) {
  try {
    yield put(actions.loadAdminData());
    yield put(actions.setSiteSuccess(siteId));
  } catch (e) {
    toast.error('An error occurred retrieving the selected organization.');
  }
}

export function* siteSagas() {
  yield takeEvery(actions.addSite, addSite);
  yield takeEvery(actions.updateSite, updateSite);
  yield takeEvery(actions.getSites, getSites);
  yield takeEvery(actions.setSite, setSite);
}
